// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__80xkD","theme-default":"IconButton_theme-default__Kf1Su","theme-role":"IconButton_theme-role__+2UJr"};